module.exports = __webpack_public_path__ + "img/send_subject.7085d69a.png";